import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";

var config = ''
if (process.env.NODE_ENV !== 'production') {
  //testing and development
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyAn9kZy87xitfGvKwKd_wVVknbNdeidUZU",
    authDomain: "setiaecopark.firebaseapp.com",
    databaseURL: "https://setiaecopark.firebaseio.com",
    projectId: "setiaecopark",
    storageBucket: "setiaecopark.appspot.com",
    messagingSenderId: "221840925949"
  };

} else {
  //production
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyAn9kZy87xitfGvKwKd_wVVknbNdeidUZU",
    authDomain: "setiaecopark.firebaseapp.com",
    databaseURL: "https://setiaecopark.firebaseio.com",
    projectId: "setiaecopark",
    storageBucket: "setiaecopark.appspot.com",
    messagingSenderId: "221840925949"
  };
}

const app = firebase.initializeApp(config);
const db = firebase.firestore(app);
const auth = firebase.auth();
const storr = firebase.storage();
const fb = firebase;
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// db.settings(settings);

export {
  auth,
  db,
  storr,
  app,
  fb
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js